export default {
    // 左侧导航
    Navigation:{
        logon:"Click to log in",
        homePage:"Home",
        explore:"Explore",
        vip:"Open VIP",
        setUp:"Set up",
        Popular:"Popular",
        liuxing:"Prevalent",
        jingdian:"Classics",
        shoucang:"RecentlyPlayed"
    },
    //顶部导航
    TOPnav:{
        sousuo:"search"
    },
    //登录页面
    logIn:{
        logtilte:"SignIn",
        input_plac:"username / email",
        input_password:"password",
        denglu:"log on",
        input_tishi_user:"username or email Cannot be empty",
        input_tishi_mima:"password Cannot be empty",
        wangji_password:"Forget password ?",
        no_username:"Don't have an account ? register",
        duowenzi:"The password is transmitted through MD5+salt encryption and saved using hash"

    },
    //个人页
    geren:{
        dongtai:"trends",
        guanzhu:"follow",
        fensi:"fans",
        el_label1:"BasicInformation",
        el_label2:"SecuritySetting",
        new_username:"new user",
        new_username_tishi:"Your nickname",
        useName:"user name",
        save:"save",
        LoginPassword:"password",
        shezhi_text:"Already set. The password must be at least 6 characters long, support both numbers and letters, and must contain both numbers and uppercase and lowercase letters.",
        modify:"modify",
        form_title_mima:"Password modification",
        from_jiumima:"Old password",
        from_tishi:"Original password incorrect",
        from_xinmima:"New password",
        from_confirm_mima:"Confirm new password",
        from_tishi2:"Two passwords are inconsistent",
        modifyMima:"Change Password",
        shiming:"certification",
        upImg:"Upload the front and back of the ID card to complete the real name authentication information. ",
        shangchuan:"Upload",
        tuichu:"Log Out"
    },
    //注册页
    zhuce:{
        // 注意事项并同意
        reg_tilte:"New user registration",
        beCareful:"If you want to register on this server, you need to confirm and agree to the following content.",
        read:"Please read carefully, this is really important.",
        fuwuGuize:"Server rules",
        guizetext1:"It is strictly prohibited to upload images and avatars that contain pornography, violence, or promote terrorism",
        guizetext2:"Prohibit sending content that violates Chinese laws",
        guizetext3:"Respect others, avoid provoking conflicts, and refrain from making offensive remarks",
        guizetext4:"Refuse meaningless screen brushing and advertising push users to register and use",
        guizetext5:"Not participating in three-dimensional key politics, including forwarding",
        yes:"agree",
        fuwu_tiaokuai:"Service Terms and Privacy Policy",
        tiaokuai:"Service Terms",
        yinsi:"Privacy Policy",
        gouXuan:"All options must be checked with 'Agree' in order to proceed to the next step",
        nextStep:"next step",
        Gologin:"I already have an account, go log in",
        // 注册
        zhucetilte:"Register",
        useName:"UserName",
        nameEnmle_input:"Username or Email",
        z_input_tishi:"Username or Email Cannot be empty",
        mima:"password",
        input_mima:"password",
        p_tilte_mima:"password Cannot be empty",
        confirm_mima:"Confirm password",
        p_tishi:"Password inconsistency",
        shouji:"cell-phone number",
        p_tishi2:"Please enter the correct phone number",
        yzm_tilte:"Verification Code",
        yzm_input_tishi:"Please enter the verification code",
        yzm_obtain:"Obtain verification code",
        yzm_cuowu:"Verification code error",
        zhuce_Button:"register",
        PreviousStep:"Previous step"
    },
    //home
    Homedata:{
        tilte1:"Single",
        tilte2:"Singer",
        tilte3:"Suggest",
        tilte4:"PopularSongs",
        shezhi1:"Regarding iOS backend playback",
        shezhi2:"Due to iOS restrictions, songs cannot be switched in the background. They can be added to the home screen or upgraded to iOS 16.1.1"
    },
    //设置
    SetUp:{
        text_tilte1:"Theme",
        text_p_Subtitle:"Customize your app theme",
        R_tilte_ys:"Theme color mode",
        R_Subtitle_ys:"System",
        R_songci_ys:"Lyrics Color Mode",
        R_songci_sub_ys:"Bright color",
        language:"Language selection",
        two_tilte:"Routine",
        donghua:"Animation",
        NOdonghua:"Disable animation effects √",
        three_tilte:"play",
        bofanglist:"playlist",
        bofang_text:"When double clicking to play a single, only add the current single to the playlist",
        four_tilte:"Shortcut keys",
        key_bofang:"Play / Pause",
        key_shang:"Previous song",
        key_xia:"Next song",
        key_yinliang_top:"Volume Up",
        key_yinliang_bou:"Volume Down",
        key_sousuo:"Open search",
        key_songci:"Close lyrics",
    },
    // 找回密码
    Retrieve:{
        zh_mima:"Retrieve password",
        shoujihao:"Registered phone number",
        p_tishi:"The phone number is incorrect",
        zhaohui:"Forgot Password"
    },
    // 单曲 列表的表头
    songList:{
        songTilte:"Music Title",
        geshou:"Singer",
        zhuanji:"Album",
        shichang:"Duration"
    },
    // 收藏
    Collect_songs:"Recently Played",
    //搜索
    search:{
        name1:"Search result",
        name2:"single"
    },
    //歌手歌单的详情页 全部播放
    PlayAll:"Play all",
    //会员页面
    member:{
        huiText2:"By opening a membership, you can unlock the lossless sound quality download permission for music across the entire site, allowing you to collect high-quality music anytime, anywhere and embark on the ultimate music experience journey.",
        huiText:"You deserve it, member recharge, one click to start high-quality life",
        huitilte:"Music VIP",
        xufei1:"Automatic renewal upon expiration",
        xufei2:"Yuan, can be manually cancelled",
        way:"Please pay with Alipay or WeChat scanning code",
        xufei:"Do you agree to the automatic renewal agreement",
        xieyi1:"《Kupi Music Service Terms》",
        xieyi2:"《Music VIP Service Terms》",
        xieyi3:"《Automatic Renewal Service Agreement》"
    }
}